import { render, staticRenderFns } from "./recommendedQuests.vue?vue&type=template&id=de7f94ba&scoped=true"
import script from "./recommendedQuests.vue?vue&type=script&lang=js"
export * from "./recommendedQuests.vue?vue&type=script&lang=js"
import style0 from "./recommendedQuests.vue?vue&type=style&index=0&id=de7f94ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7f94ba",
  null
  
)

export default component.exports